export default {
  FREEWHEEL: 'FREEWHEEL',
  SMART_AD: 'SMART_AD',
};
